export function createMarkup(txt) {
  return {__html: txt};
}
export function equalHeights(className) {
	let findClass = document.getElementsByClassName(className);
	let tallest = 0;
	for(let i = 0; i < findClass.length; i+=3)
	{
		for(let j=i;j<(i+3);j++){
			let ele = findClass[j];
			if(ele){
				let eleHeight = ele.offsetHeight;
				tallest = (eleHeight>tallest ? eleHeight : tallest);
			}
		}
		for(let j = i; j < (i+3); j++)
		{
			let ele = findClass[j];
			if(ele)
				ele.style.height = tallest + "px";
		}
	}	
}
export function today(){
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth()+1; //January is 0!

	var yyyy = today.getFullYear();
	if(dd<10){
		dd='0'+dd
	} 
	if(mm<10){
		mm='0'+mm
	} 
	today = yyyy+'/'+mm+'/'+dd;
	//today = '2021/05/10';
	return today;
}
export function children({number,offset,parent}){
	return document.jsonPath+"wp-json/wp/v2/children?number="+number+"&offset="+offset+"&parent="+parent;
}
export function getSearch({query}){
	return document.jsonPath+"wp-json/wp/v2/search?query="+query;
}
export function getStatic(){
	return document.jsonPath+"wp-json/wp/v2/static?lang="+document.language;
}
export function getPressFinal(
	slug,type,id
){
	var urlParams = document.jsonPath+"wp-json/wp/v2/pressfinal?slug="+slug+"&type="+type+"&id="+id;
	return urlParams;
}
export function getPress({
	number=1,
	offset='',
	language=document.language,
	id=''
}){
	var urlParams = document.jsonPath+"wp-json/wp/v2/press?number="+number+"&offset="+offset+"&lang="+language+'&id='+id;
	return urlParams;
}
export function getTerms(term_name){
	var urlParams = document.jsonPath+"wp-json/wp/v2/"+term_name+"?per_page=100&lang="+document.language;
	return urlParams;
}
export function getMenus({
	name=''
}){
	var urlParams = document.jsonPath+"wp-json/wp-api-menus/v2/menu-locations/"+name;
	return urlParams;
}
export function jsonUrl({number=1,
				 offset='',
				 type='',
				 id='',
				 post_parent='',
				 slug='',
				 meta_key='',
				 meta_value='',
				 orderbymeta='',
				 meta_type='',
				 order='',
				 meta_query='',
				 search='',
				 include='',
				 exclude='',
				 imageembed='',
				 pass=''
				 }){
	let urlParams = document.jsonPath+'wp-json/wp/v2/'; 
	let additionalParams = 0;
	if(type)
		urlParams = urlParams + type;
	if(id)
		urlParams = urlParams + '/' + id;
	
	urlParams = urlParams + '?';		
	additionalParams = 1;
	if(number){
		let numParams ='per_page=' + number;		
		if(additionalParams===1)
			urlParams = urlParams + '&' + numParams;
		else
			urlParams = urlParams + numParams;	
		additionalParams = 1;
	}
	if(slug){
		let slugParams = 'slug=' + slug;
		if(additionalParams===1)
			urlParams = urlParams + '&' + slugParams;
		else
			urlParams = urlParams + slugParams;
		additionalParams = 1;	
	}
	if(post_parent){
		let parentParams = 'parent=' + post_parent;
		if(additionalParams===1)
			urlParams = urlParams + '&' + parentParams;
		else
			urlParams = urlParams + parentParams;
		additionalParams = 1;	
	}
	if(offset){
		let offsetParams = 'offset=' + offset;
		if(additionalParams===1)
			urlParams = urlParams + '&' + offsetParams;
		else
			urlParams = urlParams + offsetParams;
		additionalParams = 1;	
	}		
	if(meta_key || meta_query){
		let metaParams = '';
		if(meta_key)
			metaParams = 'filter[meta_key]=' + meta_key;
		if(meta_value)	
			metaParams = metaParams + '&filter[meta_value]=' + meta_value;
		else if(meta_query){
			metaParams = metaParams + meta_query;
		}
		if(additionalParams===1)
			urlParams = urlParams + '&' + metaParams;
		else
			urlParams = urlParams + metaParams;
		additionalParams = 1;	
	}
	if(orderbymeta){
		let metaParams = 'orderby='+orderbymeta+'&order='+order;
		if(meta_type)
			metaParams = metaParams + '&filter[meta_type]='+meta_type;
		if(additionalParams===1)
			urlParams = urlParams + '&' + metaParams;
		else
			urlParams = urlParams + metaParams;
		additionalParams = 1;	
	}
	if(search){
		if(additionalParams===1)
			urlParams = urlParams + '&search='+search;
		else
			urlParams = urlParams + 'search='+search;
		additionalParams = 1;	
	}
	if(include){
		if(additionalParams===1)
			urlParams = urlParams + '&include='+include;
		else
			urlParams = urlParams + 'include='+include;
		additionalParams = 1;	
	}
	if(exclude){
		if(additionalParams===1)
			urlParams = urlParams + '&exclude='+exclude;
		else
			urlParams = urlParams + 'exclude='+exclude;
		additionalParams = 1;	
	}
	if(imageembed){
		if(additionalParams===1)
			urlParams = urlParams + '&_embed';
		else
			urlParams = urlParams + '_embed';
		additionalParams = 1;	
	}
	if(pass){
		if(additionalParams===1)
			urlParams = urlParams + '&password='+pass;
		else
			urlParams = urlParams + '&password='+pass;
		additionalParams = 1;	
	}
	return urlParams+'&lang='+document.language;
}


// WEBPACK FOOTER //
// ./src/components/Factory.js